// User profile card — click avatar to upload.
// Ảnh đi qua BE (cửa ghi duy nhất) nên hiện trên mọi máy và đồng bộ sang
// Casdoor; trước đây ảnh chỉ nằm trong localStorage của đúng máy đó.
import { useRef } from "react";
import { StaffAvatar } from "@/components/StaffAvatar";
import { StaffTitle } from "@/features/cosmetics/StaffTitle";
import { useAvatarUpload } from "@/lib/avatar-upload";

type Identity = { id: string; name: string; role: string };
type Role = { label: string; color: string };

export function SidebarProfileCard({
  identity,
  role,
}: {
  identity: Identity;
  role: Role;
}) {
  const fileRef = useRef<HTMLInputElement>(null);
  const upload = useAvatarUpload();

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // Không truyền staffId: BE tự lấy hồ sơ của phiên đang đăng nhập, nên vẫn
    // đúng người kể cả khi identity.id là mã Casdoor chưa link hồ sơ nhân sự.
    upload.mutate(
      { file },
      {
        onSettled: () => {
          if (fileRef.current) fileRef.current.value = "";
        },
      },
    );
  };

  return (
    <div
      className="m-3 flex items-center gap-2 rounded-lg px-4 py-3"
      style={{ background: "rgba(0,0,0,0.15)" }}
    >
      <button
        type="button"
        onClick={() => fileRef.current?.click()}
        title="Bấm để đổi ảnh hồ sơ"
        className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
      >
        <StaffAvatar staffId={identity.id} name={identity.name} sizePx={36} />
        <span
          className="absolute -bottom-0.5 -right-0.5 flex h-[18px] w-[18px] items-center justify-center rounded-full border-[1.5px] border-white text-[10px]"
          style={{ background: "rgba(0,0,0,0.65)" }}
        >
          {upload.isPending ? "⏳" : "📷"}
        </span>
      </button>
      <input
        ref={fileRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        onChange={handleUpload}
      />
      <div className="min-w-0 flex-1">
        <div className="truncate text-xs font-bold text-white">{identity.name}</div>
        <StaffTitle staffId={identity.id} className="block text-[#f3dcab]" />
        <div className="truncate text-[10px] text-white/95">{role.label}</div>
        {upload.isError ? (
          <div className="truncate text-[10px] text-red-100" title={(upload.error as Error).message}>
            {(upload.error as Error).message}
          </div>
        ) : null}
      </div>
    </div>
  );
}
